import { AxiosResponse } from 'axios';
import api from '../api';
import {
  IParentSubjectResponse,
  IParentSyllabusResponse,
} from '../../interface/parentSubject.interface';

// Parent (guardian) subject + syllabus endpoints (CVA-4740). The base URL
// already includes `/v2`; the server resolves the guardian link for the
// studentId in the PATH, and checks that the subject really is one the child
// takes before returning any syllabus.

const fetchParentSubjects = async (
  studentId: string,
): Promise<AxiosResponse<IParentSubjectResponse>> => {
  const response = await api.get<IParentSubjectResponse>(`/parent/subjects/student/${studentId}`);
  return response;
};

const fetchParentSyllabus = async (
  studentId: string,
  subjectAssignId: string,
): Promise<AxiosResponse<IParentSyllabusResponse>> => {
  const response = await api.get<IParentSyllabusResponse>(
    `/parent/subjects/student/${studentId}/syllabus`,
    { params: { subjectAssignId } },
  );
  return response;
};

export const parentSubjectService = {
  fetchParentSubjects,
  fetchParentSyllabus,
};
